import so, {useCallback as zr} from "react";
import {initReactI18next as uo, useTranslation as co, Trans as vo} from "../../../../pkg/react-i18next.js";
import St from "../../../../pkg/i18next.js";
var Ot = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, br = function(r) {
  return r && r.Math == Math && r;
}, c = br(typeof globalThis == "object" && globalThis) || br(typeof window == "object" && window) || br(typeof self == "object" && self) || br(typeof Ot == "object" && Ot) || function() {
  return this;
}() || Function("return this")(), rr = {}, O = function(r) {
  try {
    return !!r();
  } catch (e) {
    return true;
  }
}, fo = O, g = !fo(function() {
  return Object.defineProperty({}, 1, {
    get: function() {
      return 7;
    }
  })[1] != 7;
}), po = O, gr = !po(function() {
  var r = function() {
  }.bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), yo = gr, hr = Function.prototype.call, F = yo ? hr.bind(hr) : function() {
  return hr.apply(hr, arguments);
}, Sr = {}, wt = {}.propertyIsEnumerable, Pt = Object.getOwnPropertyDescriptor, $o = Pt && !wt.call({
  1: 2
}, 1);
Sr.f = $o ? function(e) {
  var t = Pt(this, e);
  return !!t && t.enumerable;
} : wt;
var er = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, It = gr, Tt = Function.prototype, mo = Tt.bind, qr = Tt.call, bo = It && mo.bind(qr, qr), p = It ? function(r) {
  return r && bo(r);
} : function(r) {
  return r && function() {
    return qr.apply(r, arguments);
  };
}, _t = p, go = _t({}.toString), ho = _t("".slice), Or = function(r) {
  return ho(go(r), 8, -1);
}, So = c, Oo = p, wo = O, Po = Or, Jr = So.Object, Io = Oo("".split), Et = wo(function() {
  return !Jr("z").propertyIsEnumerable(0);
}) ? function(r) {
  return Po(r) == "String" ? Io(r, "") : Jr(r);
} : Jr, To = c, _o = To.TypeError, Xr = function(r) {
  if (r == null)
    throw _o("Can't call method on " + r);
  return r;
}, Eo = Et, Ao = Xr, E = function(r) {
  return Eo(Ao(r));
}, y = function(r) {
  return typeof r == "function";
}, jo = y, M = function(r) {
  return typeof r == "object" ? r !== null : jo(r);
}, Qr = c, Ro = y, Co = function(r) {
  return Ro(r) ? r : void 0;
}, Y = function(r, e) {
  return arguments.length < 2 ? Co(Qr[r]) : Qr[r] && Qr[r][e];
}, xo = p, Zr = xo({}.isPrototypeOf), No = Y, Fo = No("navigator", "userAgent") || "", At = c, re = Fo, jt = At.process, Rt = At.Deno, Ct = jt && jt.versions || Rt && Rt.version, xt = Ct && Ct.v8, _, wr;
xt && (_ = xt.split("."), wr = _[0] > 0 && _[0] < 4 ? 1 : +(_[0] + _[1])), !wr && re && (_ = re.match(/Edge\/(\d+)/), (!_ || _[1] >= 74) && (_ = re.match(/Chrome\/(\d+)/), _ && (wr = +_[1])));
var Nt = wr, Ft = Nt, Mo = O, ee = !!Object.getOwnPropertySymbols && !Mo(function() {
  var r = Symbol();
  return !String(r) || !(Object(r) instanceof Symbol) || !Symbol.sham && Ft && Ft < 41;
}), Lo = ee, Mt = Lo && !Symbol.sham && typeof Symbol.iterator == "symbol", Do = c, Go = Y, ko = y, Vo = Zr, Ko = Mt, Uo = Do.Object, te = Ko ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = Go("Symbol");
  return ko(e) && Vo(e.prototype, Uo(r));
}, Bo = c, Wo = Bo.String, Lt = function(r) {
  try {
    return Wo(r);
  } catch (e) {
    return "Object";
  }
}, Ho = c, Yo = y, zo = Lt, qo = Ho.TypeError, ae = function(r) {
  if (Yo(r))
    return r;
  throw qo(zo(r) + " is not a function");
}, Jo = ae, ne = function(r, e) {
  var t = r[e];
  return t == null ? void 0 : Jo(t);
}, Xo = c, oe = F, ie = y, le = M, Qo = Xo.TypeError, Zo = function(r, e) {
  var t, a;
  if (e === "string" && ie(t = r.toString) && !le(a = oe(t, r)) || ie(t = r.valueOf) && !le(a = oe(t, r)) || e !== "string" && ie(t = r.toString) && !le(a = oe(t, r)))
    return a;
  throw Qo("Can't convert object to primitive value");
}, Pr = {
  exports: {}
}, Dt = c, ri = Object.defineProperty, se = function(r, e) {
  try {
    ri(Dt, r, {
      value: e,
      configurable: true,
      writable: true
    });
  } catch (t) {
    Dt[r] = e;
  }
  return e;
}, ei = c, ti = se, Gt = "__core-js_shared__", ai = ei[Gt] || ti(Gt, {}), ue = ai, kt = ue;
(Pr.exports = function(r, e) {
  return kt[r] || (kt[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.21.0",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.21.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var ni = c, oi = Xr, ii = ni.Object, tr = function(r) {
  return ii(oi(r));
}, li = p, si = tr, ui = li({}.hasOwnProperty), w = Object.hasOwn || function(e, t) {
  return ui(si(e), t);
}, ci = p, vi = 0, fi = Math.random(), pi = ci(1 .toString), ce = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + pi(++vi + fi, 36);
}, yi = c, di = Pr.exports, Vt = w, $i = ce, Kt = ee, Ut = Mt, z = di("wks"), V = yi.Symbol, Bt = V && V.for, mi = Ut ? V : V && V.withoutSetter || $i, d = function(r) {
  if (!Vt(z, r) || !(Kt || typeof z[r] == "string")) {
    var e = "Symbol." + r;
    Kt && Vt(V, r) ? z[r] = V[r] : Ut && Bt ? z[r] = Bt(e) : z[r] = mi(e);
  }
  return z[r];
}, bi = c, gi = F, Wt = M, Ht = te, hi = ne, Si = Zo, Oi = d, wi = bi.TypeError, Pi = Oi("toPrimitive"), Ii = function(r, e) {
  if (!Wt(r) || Ht(r))
    return r;
  var t = hi(r, Pi), a;
  if (t) {
    if (e === void 0 && (e = "default"), a = gi(t, r, e), !Wt(a) || Ht(a))
      return a;
    throw wi("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Si(r, e);
}, Ti = Ii, _i = te, Ir = function(r) {
  var e = Ti(r, "string");
  return _i(e) ? e : e + "";
}, Ei = c, Yt = M, ve = Ei.document, Ai = Yt(ve) && Yt(ve.createElement), fe = function(r) {
  return Ai ? ve.createElement(r) : {};
}, ji = g, Ri = O, Ci = fe, zt = !ji && !Ri(function() {
  return Object.defineProperty(Ci("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), xi = g, Ni = F, Fi = Sr, Mi = er, Li = E, Di = Ir, Gi = w, ki = zt, qt = Object.getOwnPropertyDescriptor;
rr.f = xi ? qt : function(e, t) {
  if (e = Li(e), t = Di(t), ki)
    try {
      return qt(e, t);
    } catch (a) {
    }
  if (Gi(e, t))
    return Mi(!Ni(Fi.f, e, t), e[t]);
};
var P = {}, Vi = g, Ki = O, Jt = Vi && Ki(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: false
  }).prototype != 42;
}), Xt = c, Ui = M, Bi = Xt.String, Wi = Xt.TypeError, j = function(r) {
  if (Ui(r))
    return r;
  throw Wi(Bi(r) + " is not an object");
}, Hi = c, Yi = g, zi = zt, qi = Jt, Tr = j, Qt = Ir, Ji = Hi.TypeError, pe = Object.defineProperty, Xi = Object.getOwnPropertyDescriptor, ye = "enumerable", de = "configurable", $e = "writable";
P.f = Yi ? qi ? function(e, t, a) {
  if (Tr(e), t = Qt(t), Tr(a), typeof e == "function" && t === "prototype" && "value" in a && $e in a && !a[$e]) {
    var n = Xi(e, t);
    n && n[$e] && (e[t] = a.value, a = {
      configurable: de in a ? a[de] : n[de],
      enumerable: ye in a ? a[ye] : n[ye],
      writable: false
    });
  }
  return pe(e, t, a);
} : pe : function(e, t, a) {
  if (Tr(e), t = Qt(t), Tr(a), zi)
    try {
      return pe(e, t, a);
    } catch (n) {
    }
  if ("get" in a || "set" in a)
    throw Ji("Accessors not supported");
  return "value" in a && (e[t] = a.value), e;
};
var Qi = g, Zi = P, rl = er, ar = Qi ? function(r, e, t) {
  return Zi.f(r, e, rl(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, q = {
  exports: {}
}, el = p, tl = y, me = ue, al = el(Function.toString);
tl(me.inspectSource) || (me.inspectSource = function(r) {
  return al(r);
});
var be = me.inspectSource, nl = c, ol = y, il = be, Zt = nl.WeakMap, ll = ol(Zt) && /native code/.test(il(Zt)), sl = Pr.exports, ul = ce, ra = sl("keys"), _r = function(r) {
  return ra[r] || (ra[r] = ul(r));
}, Er = {}, cl = ll, ea = c, ge = p, vl = M, fl = ar, he = w, Se = ue, pl = _r, yl = Er, ta = "Object already initialized", Oe = ea.TypeError, dl = ea.WeakMap, Ar, nr, jr, $l = function(r) {
  return jr(r) ? nr(r) : Ar(r, {});
}, ml = function(r) {
  return function(e) {
    var t;
    if (!vl(e) || (t = nr(e)).type !== r)
      throw Oe("Incompatible receiver, " + r + " required");
    return t;
  };
};
if (cl || Se.state) {
  var K = Se.state || (Se.state = new dl()), bl = ge(K.get), aa = ge(K.has), gl = ge(K.set);
  Ar = function(r, e) {
    if (aa(K, r))
      throw new Oe(ta);
    return e.facade = r, gl(K, r, e), e;
  }, nr = function(r) {
    return bl(K, r) || {};
  }, jr = function(r) {
    return aa(K, r);
  };
} else {
  var J = pl("state");
  yl[J] = true, Ar = function(r, e) {
    if (he(r, J))
      throw new Oe(ta);
    return e.facade = r, fl(r, J, e), e;
  }, nr = function(r) {
    return he(r, J) ? r[J] : {};
  }, jr = function(r) {
    return he(r, J);
  };
}
var Rr = {
  set: Ar,
  get: nr,
  has: jr,
  enforce: $l,
  getterFor: ml
}, we = g, hl = w, na = Function.prototype, Sl = we && Object.getOwnPropertyDescriptor, Pe = hl(na, "name"), Ol = Pe && function() {
}.name === "something", wl = Pe && (!we || we && Sl(na, "name").configurable), Ie = {
  EXISTS: Pe,
  PROPER: Ol,
  CONFIGURABLE: wl
}, Pl = c, oa = y, Il = w, ia = ar, Tl = se, _l = be, la = Rr, El = Ie.CONFIGURABLE, Al = la.get, jl = la.enforce, Rl = String(String).split("String");
(q.exports = function(r, e, t, a) {
  var n = a ? !!a.unsafe : false, o = a ? !!a.enumerable : false, l = a ? !!a.noTargetGet : false, i = a && a.name !== void 0 ? a.name : e, s;
  if (oa(t) && (String(i).slice(0, 7) === "Symbol(" && (i = "[" + String(i).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!Il(t, "name") || El && t.name !== i) && ia(t, "name", i), s = jl(t), s.source || (s.source = Rl.join(typeof i == "string" ? i : ""))), r === Pl) {
    o ? r[e] = t : Tl(e, t);
    return;
  } else
    n ? !l && r[e] && (o = true) : delete r[e];
  o ? r[e] = t : ia(r, e, t);
})(Function.prototype, "toString", function() {
  return oa(this) && Al(this).source || _l(this);
});
var Cr = {}, Cl = Math.ceil, xl = Math.floor, Te = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : (e > 0 ? xl : Cl)(e);
}, Nl = Te, Fl = Math.max, Ml = Math.min, _e = function(r, e) {
  var t = Nl(r);
  return t < 0 ? Fl(t + e, 0) : Ml(t, e);
}, Ll = Te, Dl = Math.min, Gl = function(r) {
  return r > 0 ? Dl(Ll(r), 9007199254740991) : 0;
}, kl = Gl, or = function(r) {
  return kl(r.length);
}, Vl = E, Kl = _e, Ul = or, sa = function(r) {
  return function(e, t, a) {
    var n = Vl(e), o = Ul(n), l = Kl(a, o), i;
    if (r && t != t) {
      for (; o > l; )
        if (i = n[l++], i != i)
          return true;
    } else
      for (; o > l; l++)
        if ((r || l in n) && n[l] === t)
          return r || l || 0;
    return !r && -1;
  };
}, Bl = {
  includes: sa(true),
  indexOf: sa(false)
}, Wl = p, Ee = w, Hl = E, Yl = Bl.indexOf, zl = Er, ua = Wl([].push), ca = function(r, e) {
  var t = Hl(r), a = 0, n = [], o;
  for (o in t)
    !Ee(zl, o) && Ee(t, o) && ua(n, o);
  for (; e.length > a; )
    Ee(t, o = e[a++]) && (~Yl(n, o) || ua(n, o));
  return n;
}, Ae = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"], ql = ca, Jl = Ae, Xl = Jl.concat("length", "prototype");
Cr.f = Object.getOwnPropertyNames || function(e) {
  return ql(e, Xl);
};
var je = {};
je.f = Object.getOwnPropertySymbols;
var Ql = Y, Zl = p, rs = Cr, es = je, ts = j, as = Zl([].concat), va = Ql("Reflect", "ownKeys") || function(e) {
  var t = rs.f(ts(e)), a = es.f;
  return a ? as(t, a(e)) : t;
}, fa = w, ns = va, os = rr, is = P, pa = function(r, e, t) {
  for (var a = ns(e), n = is.f, o = os.f, l = 0; l < a.length; l++) {
    var i = a[l];
    !fa(r, i) && !(t && fa(t, i)) && n(r, i, o(e, i));
  }
}, ls = O, ss = y, us = /#|\.prototype\./, ir = function(r, e) {
  var t = vs[cs(r)];
  return t == ps ? true : t == fs ? false : ss(e) ? ls(e) : !!e;
}, cs = ir.normalize = function(r) {
  return String(r).replace(us, ".").toLowerCase();
}, vs = ir.data = {}, fs = ir.NATIVE = "N", ps = ir.POLYFILL = "P", ys = ir, Re = c, ds = rr.f, $s = ar, ms = q.exports, bs = se, gs = pa, hs = ys, U = function(r, e) {
  var t = r.target, a = r.global, n = r.stat, o, l, i, s, u, v;
  if (a ? l = Re : n ? l = Re[t] || bs(t, {}) : l = (Re[t] || {}).prototype, l)
    for (i in e) {
      if (u = e[i], r.noTargetGet ? (v = ds(l, i), s = v && v.value) : s = l[i], o = hs(a ? i : t + (n ? "." : "#") + i, r.forced), !o && s !== void 0) {
        if (typeof u == typeof s)
          continue;
        gs(u, s);
      }
      (r.sham || s && s.sham) && $s(u, "sham", true), ms(l, i, u, r);
    }
}, Ss = gr, ya = Function.prototype, da = ya.apply, $a = ya.call, Os = typeof Reflect == "object" && Reflect.apply || (Ss ? $a.bind(da) : function() {
  return $a.apply(da, arguments);
}), ws = Or, Ce = Array.isArray || function(e) {
  return ws(e) == "Array";
}, Ps = d, Is = Ps("toStringTag"), ma = {};
ma[Is] = "z";
var xe = String(ma) === "[object z]", Ts = c, _s = xe, Es = y, xr = Or, As = d, js = As("toStringTag"), Rs = Ts.Object, Cs = xr(function() {
  return arguments;
}()) == "Arguments", xs = function(r, e) {
  try {
    return r[e];
  } catch (t) {
  }
}, Nr = _s ? xr : function(r) {
  var e, t, a;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = xs(e = Rs(r), js)) == "string" ? t : Cs ? xr(e) : (a = xr(e)) == "Object" && Es(e.callee) ? "Arguments" : a;
}, Ns = c, Fs = Nr, Ms = Ns.String, Fr = function(r) {
  if (Fs(r) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return Ms(r);
}, Ne = {}, Ls = ca, Ds = Ae, Fe = Object.keys || function(e) {
  return Ls(e, Ds);
}, Gs = g, ks = Jt, Vs = P, Ks = j, Us = E, Bs = Fe;
Ne.f = Gs && !ks ? Object.defineProperties : function(e, t) {
  Ks(e);
  for (var a = Us(t), n = Bs(t), o = n.length, l = 0, i; o > l; )
    Vs.f(e, i = n[l++], a[i]);
  return e;
};
var Ws = Y, Hs = Ws("document", "documentElement"), Ys = j, zs = Ne, ba = Ae, qs = Er, Js = Hs, Xs = fe, Qs = _r, ga = ">", ha = "<", Me = "prototype", Le = "script", Sa = Qs("IE_PROTO"), De = function() {
}, Oa = function(r) {
  return ha + Le + ga + r + ha + "/" + Le + ga;
}, wa = function(r) {
  r.write(Oa("")), r.close();
  var e = r.parentWindow.Object;
  return r = null, e;
}, Zs = function() {
  var r = Xs("iframe"), e = "java" + Le + ":", t;
  return r.style.display = "none", Js.appendChild(r), r.src = String(e), t = r.contentWindow.document, t.open(), t.write(Oa("document.F=Object")), t.close(), t.F;
}, Mr, Lr = function() {
  try {
    Mr = new ActiveXObject("htmlfile");
  } catch (e) {
  }
  Lr = typeof document != "undefined" ? document.domain && Mr ? wa(Mr) : Zs() : wa(Mr);
  for (var r = ba.length; r--; )
    delete Lr[Me][ba[r]];
  return Lr();
};
qs[Sa] = true;
var Ge = Object.create || function(e, t) {
  var a;
  return e !== null ? (De[Me] = Ys(e), a = new De(), De[Me] = null, a[Sa] = e) : a = Lr(), t === void 0 ? a : zs.f(a, t);
}, Pa = {}, ru = Ir, eu = P, tu = er, Dr = function(r, e, t) {
  var a = ru(e);
  a in r ? eu.f(r, a, tu(0, t)) : r[a] = t;
}, au = c, Ia = _e, nu = or, ou = Dr, iu = au.Array, lu = Math.max, su = function(r, e, t) {
  for (var a = nu(r), n = Ia(e, a), o = Ia(t === void 0 ? a : t, a), l = iu(lu(o - n, 0)), i = 0; n < o; n++, i++)
    ou(l, i, r[n]);
  return l.length = i, l;
}, uu = Or, cu = E, Ta = Cr.f, vu = su, _a = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], fu = function(r) {
  try {
    return Ta(r);
  } catch (e) {
    return vu(_a);
  }
};
Pa.f = function(e) {
  return _a && uu(e) == "Window" ? fu(e) : Ta(cu(e));
};
var pu = p, Ea = pu([].slice), ke = {}, yu = d;
ke.f = yu;
var du = c, $u = du, Aa = $u, mu = w, bu = ke, gu = P.f, ja = function(r) {
  var e = Aa.Symbol || (Aa.Symbol = {});
  mu(e, r) || gu(e, r, {
    value: bu.f(r)
  });
}, hu = P.f, Su = w, Ou = d, Ra = Ou("toStringTag"), Ve = function(r, e, t) {
  r && !t && (r = r.prototype), r && !Su(r, Ra) && hu(r, Ra, {
    configurable: true,
    value: e
  });
}, Ca = p, wu = ae, Pu = gr, Iu = Ca(Ca.bind), xa = function(r, e) {
  return wu(r), e === void 0 ? r : Pu ? Iu(r, e) : function() {
    return r.apply(e, arguments);
  };
}, Tu = p, _u = O, Na = y, Eu = Nr, Au = Y, ju = be, Fa = function() {
}, Ru = [], Ma = Au("Reflect", "construct"), Ke = /^\s*(?:class|function)\b/, Cu = Tu(Ke.exec), xu = !Ke.exec(Fa), lr = function(e) {
  if (!Na(e))
    return false;
  try {
    return Ma(Fa, Ru, e), true;
  } catch (t) {
    return false;
  }
}, La = function(e) {
  if (!Na(e))
    return false;
  switch (Eu(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return false;
  }
  try {
    return xu || !!Cu(Ke, ju(e));
  } catch (t) {
    return true;
  }
};
La.sham = true;
var Ue = !Ma || _u(function() {
  var r;
  return lr(lr.call) || !lr(Object) || !lr(function() {
    r = true;
  }) || r;
}) ? La : lr, Nu = c, Da = Ce, Fu = Ue, Mu = M, Lu = d, Du = Lu("species"), Ga = Nu.Array, Gu = function(r) {
  var e;
  return Da(r) && (e = r.constructor, Fu(e) && (e === Ga || Da(e.prototype)) ? e = void 0 : Mu(e) && (e = e[Du], e === null && (e = void 0))), e === void 0 ? Ga : e;
}, ku = Gu, Vu = function(r, e) {
  return new (ku(r))(e === 0 ? 0 : e);
}, Ku = xa, Uu = p, Bu = Et, Wu = tr, Hu = or, Yu = Vu, ka = Uu([].push), L = function(r) {
  var e = r == 1, t = r == 2, a = r == 3, n = r == 4, o = r == 6, l = r == 7, i = r == 5 || o;
  return function(s, u, v, h) {
    for (var $ = Wu(s), A = Bu($), m = Ku(u, v), N = Hu(A), S = 0, T = h || Yu, k = e ? T(s, N) : t || l ? T(s, 0) : void 0, Z, Yr; N > S; S++)
      if ((i || S in A) && (Z = A[S], Yr = m(Z, S, $), r))
        if (e)
          k[S] = Yr;
        else if (Yr)
          switch (r) {
            case 3:
              return true;
            case 5:
              return Z;
            case 6:
              return S;
            case 2:
              ka(k, Z);
          }
        else
          switch (r) {
            case 4:
              return false;
            case 7:
              ka(k, Z);
          }
    return o ? -1 : a || n ? n : k;
  };
}, zu = {
  forEach: L(0),
  map: L(1),
  filter: L(2),
  some: L(3),
  every: L(4),
  find: L(5),
  findIndex: L(6),
  filterReject: L(7)
}, X = U, Be = c, qu = Y, Ju = Os, sr = F, Xu = p, Q = g, B = ee, We = O, f = w, Qu = Ce, Zu = y, rc = M, ec = Zr, He = te, Ye = j, tc = tr, Gr = E, ze = Ir, Va = Fr, qe = er, ur = Ge, Ka = Fe, ac = Cr, Ua = Pa, Je = je, Ba = rr, Wa = P, nc = Ne, Ha = Sr, oc = Ea, kr = q.exports, cr = Pr.exports, ic = _r, Ya = Er, za = ce, qa = d, lc = ke, sc = ja, uc = Ve, Ja = Rr, Vr = zu.forEach, b = ic("hidden"), Kr = "Symbol", vr = "prototype", Xa = qa("toPrimitive"), cc = Ja.set, Qa = Ja.getterFor(Kr), I = Object[vr], R = Be.Symbol, D = R && R[vr], Za = Be.TypeError, Xe = Be.QObject, fr = qu("JSON", "stringify"), rn = Ba.f, G = Wa.f, en = Ua.f, vc = Ha.f, tn = Xu([].push), C = cr("symbols"), pr = cr("op-symbols"), Qe = cr("string-to-symbol-registry"), Ze = cr("symbol-to-string-registry"), fc = cr("wks"), rt = !Xe || !Xe[vr] || !Xe[vr].findChild, et = Q && We(function() {
  return ur(G({}, "a", {
    get: function() {
      return G(this, "a", {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function(r, e, t) {
  var a = rn(I, e);
  a && delete I[e], G(r, e, t), a && r !== I && G(I, e, a);
} : G, tt = function(r, e) {
  var t = C[r] = ur(D);
  return cc(t, {
    type: Kr,
    tag: r,
    description: e
  }), Q || (t.description = e), t;
}, Ur = function(e, t, a) {
  e === I && Ur(pr, t, a), Ye(e);
  var n = ze(t);
  return Ye(a), f(C, n) ? (a.enumerable ? (f(e, b) && e[b][n] && (e[b][n] = false), a = ur(a, {
    enumerable: qe(0, false)
  })) : (f(e, b) || G(e, b, qe(1, {})), e[b][n] = true), et(e, n, a)) : G(e, n, a);
}, at = function(e, t) {
  Ye(e);
  var a = Gr(t), n = Ka(a).concat(ot(a));
  return Vr(n, function(o) {
    (!Q || sr(nt, a, o)) && Ur(e, o, a[o]);
  }), e;
}, pc = function(e, t) {
  return t === void 0 ? ur(e) : at(ur(e), t);
}, nt = function(e) {
  var t = ze(e), a = sr(vc, this, t);
  return this === I && f(C, t) && !f(pr, t) ? false : a || !f(this, t) || !f(C, t) || f(this, b) && this[b][t] ? a : true;
}, an = function(e, t) {
  var a = Gr(e), n = ze(t);
  if (!(a === I && f(C, n) && !f(pr, n))) {
    var o = rn(a, n);
    return o && f(C, n) && !(f(a, b) && a[b][n]) && (o.enumerable = true), o;
  }
}, nn = function(e) {
  var t = en(Gr(e)), a = [];
  return Vr(t, function(n) {
    !f(C, n) && !f(Ya, n) && tn(a, n);
  }), a;
}, ot = function(e) {
  var t = e === I, a = en(t ? pr : Gr(e)), n = [];
  return Vr(a, function(o) {
    f(C, o) && (!t || f(I, o)) && tn(n, C[o]);
  }), n;
};
if (B || (R = function() {
  if (ec(D, this))
    throw Za("Symbol is not a constructor");
  var e = !arguments.length || arguments[0] === void 0 ? void 0 : Va(arguments[0]), t = za(e), a = function(n) {
    this === I && sr(a, pr, n), f(this, b) && f(this[b], t) && (this[b][t] = false), et(this, t, qe(1, n));
  };
  return Q && rt && et(I, t, {
    configurable: true,
    set: a
  }), tt(t, e);
}, D = R[vr], kr(D, "toString", function() {
  return Qa(this).tag;
}), kr(R, "withoutSetter", function(r) {
  return tt(za(r), r);
}), Ha.f = nt, Wa.f = Ur, nc.f = at, Ba.f = an, ac.f = Ua.f = nn, Je.f = ot, lc.f = function(r) {
  return tt(qa(r), r);
}, Q && (G(D, "description", {
  configurable: true,
  get: function() {
    return Qa(this).description;
  }
}), kr(I, "propertyIsEnumerable", nt, {
  unsafe: true
}))), X({
  global: true,
  wrap: true,
  forced: !B,
  sham: !B
}, {
  Symbol: R
}), Vr(Ka(fc), function(r) {
  sc(r);
}), X({
  target: Kr,
  stat: true,
  forced: !B
}, {
  for: function(r) {
    var e = Va(r);
    if (f(Qe, e))
      return Qe[e];
    var t = R(e);
    return Qe[e] = t, Ze[t] = e, t;
  },
  keyFor: function(e) {
    if (!He(e))
      throw Za(e + " is not a symbol");
    if (f(Ze, e))
      return Ze[e];
  },
  useSetter: function() {
    rt = true;
  },
  useSimple: function() {
    rt = false;
  }
}), X({
  target: "Object",
  stat: true,
  forced: !B,
  sham: !Q
}, {
  create: pc,
  defineProperty: Ur,
  defineProperties: at,
  getOwnPropertyDescriptor: an
}), X({
  target: "Object",
  stat: true,
  forced: !B
}, {
  getOwnPropertyNames: nn,
  getOwnPropertySymbols: ot
}), X({
  target: "Object",
  stat: true,
  forced: We(function() {
    Je.f(1);
  })
}, {
  getOwnPropertySymbols: function(e) {
    return Je.f(tc(e));
  }
}), fr) {
  var yc = !B || We(function() {
    var r = R();
    return fr([r]) != "[null]" || fr({
      a: r
    }) != "{}" || fr(Object(r)) != "{}";
  });
  X({
    target: "JSON",
    stat: true,
    forced: yc
  }, {
    stringify: function(e, t, a) {
      var n = oc(arguments), o = t;
      if (!(!rc(t) && e === void 0 || He(e)))
        return Qu(t) || (t = function(l, i) {
          if (Zu(o) && (i = sr(o, this, l, i)), !He(i))
            return i;
        }), n[1] = t, Ju(fr, null, n);
    }
  });
}
if (!D[Xa]) {
  var dc = D.valueOf;
  kr(D, Xa, function(r) {
    return sr(dc, this);
  });
}
uc(R, Kr), Ya[b] = true;
var $c = O, mc = d, bc = Nt, gc = mc("species"), hc = function(r) {
  return bc >= 51 || !$c(function() {
    var e = [], t = e.constructor = {};
    return t[gc] = function() {
      return {
        foo: 1
      };
    }, e[r](Boolean).foo !== 1;
  });
}, Sc = U, Oc = c, on = Ce, wc = Ue, Pc = M, ln = _e, Ic = or, Tc = E, _c = Dr, Ec = d, Ac = hc, jc = Ea, Rc = Ac("slice"), Cc = Ec("species"), it = Oc.Array, xc = Math.max;
Sc({
  target: "Array",
  proto: true,
  forced: !Rc
}, {
  slice: function(e, t) {
    var a = Tc(this), n = Ic(a), o = ln(e, n), l = ln(t === void 0 ? n : t, n), i, s, u;
    if (on(a) && (i = a.constructor, wc(i) && (i === it || on(i.prototype)) ? i = void 0 : Pc(i) && (i = i[Cc], i === null && (i = void 0)), i === it || i === void 0))
      return jc(a, o, l);
    for (s = new (i === void 0 ? it : i)(xc(l - o, 0)), u = 0; o < l; o++, u++)
      o in a && _c(s, u, a[o]);
    return s.length = u, s;
  }
});
var Nc = xe, Fc = Nr, Mc = Nc ? {}.toString : function() {
  return "[object " + Fc(this) + "]";
}, Lc = xe, Dc = q.exports, Gc = Mc;
Lc || Dc(Object.prototype, "toString", Gc, {
  unsafe: true
});
var kc = g, Vc = Ie.EXISTS, sn = p, Kc = P.f, un = Function.prototype, Uc = sn(un.toString), cn = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, Bc = sn(cn.exec), Wc = "name";
kc && !Vc && Kc(un, Wc, {
  configurable: true,
  get: function() {
    try {
      return Bc(cn, Uc(this))[1];
    } catch (r) {
      return "";
    }
  }
});
var Hc = F, vn = j, Yc = ne, zc = function(r, e, t) {
  var a, n;
  vn(r);
  try {
    if (a = Yc(r, "return"), !a) {
      if (e === "throw")
        throw t;
      return t;
    }
    a = Hc(a, r);
  } catch (o) {
    n = true, a = o;
  }
  if (e === "throw")
    throw t;
  if (n)
    throw a;
  return vn(a), t;
}, qc = j, Jc = zc, Xc = function(r, e, t, a) {
  try {
    return a ? e(qc(t)[0], t[1]) : e(t);
  } catch (n) {
    Jc(r, "throw", n);
  }
}, yr = {}, Qc = d, Zc = yr, rv = Qc("iterator"), ev = Array.prototype, tv = function(r) {
  return r !== void 0 && (Zc.Array === r || ev[rv] === r);
}, av = Nr, fn = ne, nv = yr, ov = d, iv = ov("iterator"), pn = function(r) {
  if (r != null)
    return fn(r, iv) || fn(r, "@@iterator") || nv[av(r)];
}, lv = c, sv = F, uv = ae, cv = j, vv = Lt, fv = pn, pv = lv.TypeError, yv = function(r, e) {
  var t = arguments.length < 2 ? fv(r) : e;
  if (uv(t))
    return cv(sv(t, r));
  throw pv(vv(r) + " is not iterable");
}, dv = c, $v = xa, mv = F, bv = tr, gv = Xc, hv = tv, Sv = Ue, Ov = or, yn = Dr, wv = yv, Pv = pn, dn = dv.Array, Iv = function(e) {
  var t = bv(e), a = Sv(this), n = arguments.length, o = n > 1 ? arguments[1] : void 0, l = o !== void 0;
  l && (o = $v(o, n > 2 ? arguments[2] : void 0));
  var i = Pv(t), s = 0, u, v, h, $, A, m;
  if (i && !(this == dn && hv(i)))
    for ($ = wv(t, i), A = $.next, v = a ? new this() : []; !(h = mv(A, $)).done; s++)
      m = l ? gv($, o, [h.value, s], true) : h.value, yn(v, s, m);
  else
    for (u = Ov(t), v = a ? new this(u) : dn(u); u > s; s++)
      m = l ? o(t[s], s) : t[s], yn(v, s, m);
  return v.length = s, v;
}, Tv = d, $n = Tv("iterator"), mn = false;
try {
  var _v = 0, bn = {
    next: function() {
      return {
        done: !!_v++
      };
    },
    return: function() {
      mn = true;
    }
  };
  bn[$n] = function() {
    return this;
  }, Array.from(bn, function() {
    throw 2;
  });
} catch (r) {
}
var Ev = function(r, e) {
  if (!e && !mn)
    return false;
  var t = false;
  try {
    var a = {};
    a[$n] = function() {
      return {
        next: function() {
          return {
            done: t = true
          };
        }
      };
    }, r(a);
  } catch (n) {
  }
  return t;
}, Av = U, jv = Iv, Rv = Ev, Cv = !Rv(function(r) {
  Array.from(r);
});
Av({
  target: "Array",
  stat: true,
  forced: Cv
}, {
  from: jv
});
var lt = p, xv = Te, Nv = Fr, Fv = Xr, Mv = lt("".charAt), gn = lt("".charCodeAt), Lv = lt("".slice), hn = function(r) {
  return function(e, t) {
    var a = Nv(Fv(e)), n = xv(t), o = a.length, l, i;
    return n < 0 || n >= o ? r ? "" : void 0 : (l = gn(a, n), l < 55296 || l > 56319 || n + 1 === o || (i = gn(a, n + 1)) < 56320 || i > 57343 ? r ? Mv(a, n) : l : r ? Lv(a, n, n + 2) : (l - 55296 << 10) + (i - 56320) + 65536);
  };
}, Dv = {
  codeAt: hn(false),
  charAt: hn(true)
}, Gv = O, kv = !Gv(function() {
  function r() {
  }
  return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), Vv = c, Kv = w, Uv = y, Bv = tr, Wv = _r, Hv = kv, Sn = Wv("IE_PROTO"), st = Vv.Object, Yv = st.prototype, On = Hv ? st.getPrototypeOf : function(r) {
  var e = Bv(r);
  if (Kv(e, Sn))
    return e[Sn];
  var t = e.constructor;
  return Uv(t) && e instanceof t ? t.prototype : e instanceof st ? Yv : null;
}, zv = O, qv = y, wn = On, Jv = q.exports, Xv = d, ut = Xv("iterator"), Pn = false, W, ct, vt;
[].keys && (vt = [].keys(), "next" in vt ? (ct = wn(wn(vt)), ct !== Object.prototype && (W = ct)) : Pn = true);
var Qv = W == null || zv(function() {
  var r = {};
  return W[ut].call(r) !== r;
});
Qv && (W = {}), qv(W[ut]) || Jv(W, ut, function() {
  return this;
});
var In = {
  IteratorPrototype: W,
  BUGGY_SAFARI_ITERATORS: Pn
}, Zv = In.IteratorPrototype, rf = Ge, ef = er, tf = Ve, af = yr, nf = function() {
  return this;
}, of = function(r, e, t, a) {
  var n = e + " Iterator";
  return r.prototype = rf(Zv, {
    next: ef(+!a, t)
  }), tf(r, n, false), af[n] = nf, r;
}, Tn = c, lf = y, sf = Tn.String, uf = Tn.TypeError, cf = function(r) {
  if (typeof r == "object" || lf(r))
    return r;
  throw uf("Can't set " + sf(r) + " as a prototype");
}, vf = p, ff = j, pf = cf, yf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var r = false, e = {}, t;
  try {
    t = vf(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), t(e, []), r = e instanceof Array;
  } catch (a) {
  }
  return function(n, o) {
    return ff(n), pf(o), r ? t(n, o) : n.__proto__ = o, n;
  };
}() : void 0), df = U, $f = F, _n = Ie, mf = y, bf = of, En = On, An = yf, gf = Ve, hf = ar, ft = q.exports, Sf = d, Of = yr, jn = In, wf = _n.PROPER, Pf = _n.CONFIGURABLE, Rn = jn.IteratorPrototype, Br = jn.BUGGY_SAFARI_ITERATORS, dr = Sf("iterator"), Cn = "keys", $r = "values", xn = "entries", If = function() {
  return this;
}, Nn = function(r, e, t, a, n, o, l) {
  bf(t, e, a);
  var i = function(T) {
    if (T === n && $)
      return $;
    if (!Br && T in v)
      return v[T];
    switch (T) {
      case Cn:
        return function() {
          return new t(this, T);
        };
      case $r:
        return function() {
          return new t(this, T);
        };
      case xn:
        return function() {
          return new t(this, T);
        };
    }
    return function() {
      return new t(this);
    };
  }, s = e + " Iterator", u = false, v = r.prototype, h = v[dr] || v["@@iterator"] || n && v[n], $ = !Br && h || i(n), A = e == "Array" && v.entries || h, m, N, S;
  if (A && (m = En(A.call(new r())), m !== Object.prototype && m.next && (En(m) !== Rn && (An ? An(m, Rn) : mf(m[dr]) || ft(m, dr, If)), gf(m, s, true))), wf && n == $r && h && h.name !== $r && (Pf ? hf(v, "name", $r) : (u = true, $ = function() {
    return $f(h, this);
  })), n)
    if (N = {
      values: i($r),
      keys: o ? $ : i(Cn),
      entries: i(xn)
    }, l)
      for (S in N)
        (Br || u || !(S in v)) && ft(v, S, N[S]);
    else
      df({
        target: e,
        proto: true,
        forced: Br || u
      }, N);
  return v[dr] !== $ && ft(v, dr, $, {
    name: n
  }), Of[e] = $, N;
}, Tf = Dv.charAt, _f = Fr, Fn = Rr, Ef = Nn, Mn = "String Iterator", Af = Fn.set, jf = Fn.getterFor(Mn);
Ef(String, "String", function(r) {
  Af(this, {
    type: Mn,
    string: _f(r),
    index: 0
  });
}, function() {
  var e = jf(this), t = e.string, a = e.index, n;
  return a >= t.length ? {
    value: void 0,
    done: true
  } : (n = Tf(t, a), e.index += n.length, {
    value: n,
    done: false
  });
});
var Rf = U, Cf = g, xf = c, Wr = p, Nf = w, Ff = y, Mf = Zr, Lf = Fr, Df = P.f, Gf = pa, x = xf.Symbol, H = x && x.prototype;
if (Cf && Ff(x) && (!("description" in H) || x().description !== void 0)) {
  var Ln = {}, Hr = function() {
    var e = arguments.length < 1 || arguments[0] === void 0 ? void 0 : Lf(arguments[0]), t = Mf(H, this) ? new x(e) : e === void 0 ? x() : x(e);
    return e === "" && (Ln[t] = true), t;
  };
  Gf(Hr, x), Hr.prototype = H, H.constructor = Hr;
  var kf = String(x("test")) == "Symbol(test)", Vf = Wr(H.toString), Kf = Wr(H.valueOf), Uf = /^Symbol\((.*)\)[^)]+$/, Bf = Wr("".replace), Wf = Wr("".slice);
  Df(H, "description", {
    configurable: true,
    get: function() {
      var e = Kf(this), t = Vf(e);
      if (Nf(Ln, e))
        return "";
      var a = kf ? Wf(t, 7, -1) : Bf(t, Uf, "$1");
      return a === "" ? void 0 : a;
    }
  }), Rf({
    global: true,
    forced: true
  }, {
    Symbol: Hr
  });
}
var Hf = ja;
Hf("iterator");
var Yf = d, zf = Ge, qf = P, pt = Yf("unscopables"), yt = Array.prototype;
yt[pt] == null && qf.f(yt, pt, {
  configurable: true,
  value: zf(null)
});
var Jf = function(r) {
  yt[pt][r] = true;
}, Xf = E, dt = Jf, Dn = yr, Gn = Rr, Qf = P.f, Zf = Nn, rp = g, kn = "Array Iterator", ep = Gn.set, tp = Gn.getterFor(kn), ap = Zf(Array, "Array", function(r, e) {
  ep(this, {
    type: kn,
    target: Xf(r),
    index: 0,
    kind: e
  });
}, function() {
  var r = tp(this), e = r.target, t = r.kind, a = r.index++;
  return !e || a >= e.length ? (r.target = void 0, {
    value: void 0,
    done: true
  }) : t == "keys" ? {
    value: a,
    done: false
  } : t == "values" ? {
    value: e[a],
    done: false
  } : {
    value: [a, e[a]],
    done: false
  };
}, "values"), Vn = Dn.Arguments = Dn.Array;
if (dt("keys"), dt("values"), dt("entries"), rp && Vn.name !== "values")
  try {
    Qf(Vn, "name", {
      value: "values"
    });
  } catch (r) {
  }
var np = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, op = fe, $t = op("span").classList, Kn = $t && $t.constructor && $t.constructor.prototype, ip = Kn === Object.prototype ? void 0 : Kn, Un = c, Bn = np, lp = ip, mr = ap, mt = ar, Wn = d, bt = Wn("iterator"), Hn = Wn("toStringTag"), gt = mr.values, Yn = function(r, e) {
  if (r) {
    if (r[bt] !== gt)
      try {
        mt(r, bt, gt);
      } catch (a) {
        r[bt] = gt;
      }
    if (r[Hn] || mt(r, Hn, e), Bn[e]) {
      for (var t in mr)
        if (r[t] !== mr[t])
          try {
            mt(r, t, mr[t]);
          } catch (a) {
            r[t] = mr[t];
          }
    }
  }
};
for (var ht in Bn)
  Yn(Un[ht] && Un[ht].prototype, ht);
Yn(lp, "DOMTokenList");
function sp(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : r[e] = t, r;
}
function up(r) {
  if (Array.isArray(r))
    return r;
}
function cp(r, e) {
  var t = r == null ? null : typeof Symbol != "undefined" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var a = [], n = true, o = false, l, i;
    try {
      for (t = t.call(r); !(n = (l = t.next()).done) && (a.push(l.value), !(e && a.length === e)); n = true)
        ;
    } catch (s) {
      o = true, i = s;
    } finally {
      try {
        !n && t.return != null && t.return();
      } finally {
        if (o)
          throw i;
      }
    }
    return a;
  }
}
function zn(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, a = new Array(e); t < e; t++)
    a[t] = r[t];
  return a;
}
function vp(r, e) {
  if (!!r) {
    if (typeof r == "string")
      return zn(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return zn(r, e);
  }
}
function fp() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pp(r, e) {
  return up(r) || cp(r, e) || vp(r, e) || fp();
}
var yp = U, dp = g, $p = va, mp = E, bp = rr, gp = Dr;
yp({
  target: "Object",
  stat: true,
  sham: !dp
}, {
  getOwnPropertyDescriptors: function(e) {
    for (var t = mp(e), a = bp.f, n = $p(t), o = {}, l = 0, i, s; n.length > l; )
      s = a(t, i = n[l++]), s !== void 0 && gp(o, i, s);
    return o;
  }
});
var hp = g, qn = p, Sp = Fe, Op = E, wp = Sr.f, Pp = qn(wp), Ip = qn([].push), Jn = function(r) {
  return function(e) {
    for (var t = Op(e), a = Sp(t), n = a.length, o = 0, l = [], i; n > o; )
      i = a[o++], (!hp || Pp(t, i)) && Ip(l, r ? [i, t[i]] : t[i]);
    return l;
  };
}, Tp = {
  entries: Jn(true),
  values: Jn(false)
}, _p = U, Ep = Tp.entries;
_p({
  target: "Object",
  stat: true
}, {
  entries: function(e) {
    return Ep(e);
  }
});
var Xn = {
  title: "Account permissions",
  selectAll: "Select all Permissions",
  dashboard: {
    title: "Dashboard",
    view: "View dashboard"
  },
  property: {
    title: "Property group",
    view: "View property groups"
  },
  unit: {
    title: "Unit",
    view: "View units"
  },
  document: {
    title: "Document",
    manager: "View document manager",
    setup: "View setup of document manager"
  },
  template: {
    title: "Template",
    view: "View templates",
    calendar: "View template calendar",
    trigger: "View trigger templates",
    code: "View code templates tasks",
    codeHelp: "Activating or deactivating this permission implies changes to the account that may take a while. If the changes in the account are not reflected within a maximum of 30min, contact the Admin."
  },
  workflow: {
    title: "WorkFlow",
    view: "View workflows"
  },
  unitWorkflow: {
    title: "Unit WorkFlow",
    view: "View unit workflows",
    make: "View make ready board",
    residentInspection: "Resident Inspections Enabled"
  },
  dynamicForm: {
    title: "Dynamic form",
    view: "View dynamic forms"
  },
  demand: {
    title: "On demand instructions",
    view: "View on demand instructions"
  },
  report: {
    title: "Report",
    view: "View reports",
    mimo: "View MIMO reports"
  },
  contact: {
    title: "Contact",
    view: "View contacts"
  },
  workOrder: {
    title: "Work Order",
    view: "View work orders"
  },
  sftp: {
    title: "SFTP",
    upload: "Upload SFTP"
  },
  messenger: {
    title: "Messenger",
    live: "Live Messenger"
  },
  help: {
    title: "Help",
    help: "View Help"
  },
  other: {
    title: "Other",
    photo: "Mobile Photo Annotation"
  },
  approvalStep: {
    title: "Approval Step",
    define: "Define Approval Steps"
  },
  sso: {
    title: "SSO",
    login: "Login with SSO",
    properties: "Get properties from Idp",
    roles: "Get roles from Idp"
  }
}, Ap = {
  list: {
    title: "Account List",
    add: "Add new account"
  },
  table: {
    empty: "No accounts",
    whiteLabel: "White label",
    name: "Name",
    alias: "Alias",
    sector: "Sector",
    status: "Status",
    fullName: "Full name",
    email: "Email",
    actions: "Actions"
  },
  content: {
    titleAdd: "Add new account",
    titleEdit: "Edit account",
    accountForm: {
      title: "Account fields",
      name: "Name",
      timezone: "Timezone",
      sector: "Sector",
      sectorPlaceholder: "Select a Sector",
      country: "Country",
      countryPlaceholder: "Select a Country",
      status: "Status",
      statusPlaceholder: "Select a Status",
      whiteLabel: "White Label",
      whiteLabelPlaceholder: "Select a White Label"
    },
    permissionsSection: {
      title: "Permissions"
    },
    accountPermissions: Xn,
    userForm: {
      title: "User fields",
      firstName: "First name",
      lastName: "Last name",
      password: "Password",
      passwordHint: "min 8 characters; mix letters and numbers",
      confirmPassword: "Confirm password",
      email: "Email"
    }
  },
  status: {
    0: "Pending",
    1: "Active",
    2: "On Boarding",
    3: "Rejected"
  }
}, jp = {
  content: "Drag your photo file here or click to upload"
}, Rp = {
  label: "Pagination Navigation",
  previous: "Previous page",
  next: "Next page",
  current: "Current Page, Page {{ num }}",
  goto: "Goto Page {{ num }}"
};
function Cp(r, e) {
  var t = typeof Symbol != "undefined" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = xp(r)) || e && r && typeof r.length == "number") {
      t && (r = t);
      var a = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return a >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[a++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = true, l = false, i;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var u = t.next();
      return o = u.done, u;
    },
    e: function(u) {
      l = true, i = u;
    },
    f: function() {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (l)
          throw i;
      }
    }
  };
}
function xp(r, e) {
  if (!!r) {
    if (typeof r == "string")
      return Qn(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Qn(r, e);
  }
}
function Qn(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, a = new Array(e); t < e; t++)
    a[t] = r[t];
  return a;
}
var Np = Object.defineProperty, Fp = Object.defineProperties, Mp = Object.getOwnPropertyDescriptors, Zn = Object.getOwnPropertySymbols, Lp = Object.prototype.hasOwnProperty, Dp = Object.prototype.propertyIsEnumerable, ro = function(e, t, a) {
  return t in e ? Np(e, t, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: a
  }) : e[t] = a;
}, Gp = function(e, t) {
  for (var a in t || (t = {}))
    Lp.call(t, a) && ro(e, a, t[a]);
  if (Zn) {
    var n = Cp(Zn(t)), o;
    try {
      for (n.s(); !(o = n.n()).done; ) {
        var a = o.value;
        Dp.call(t, a) && ro(e, a, t[a]);
      }
    } catch (l) {
      n.e(l);
    } finally {
      n.f();
    }
  }
  return e;
}, kp = function(e, t) {
  return Fp(e, Mp(t));
}, Vp = {
  list: {
    title: "White Label List",
    add: "Add new Client Instance"
  },
  table: {
    empty: "No client instance",
    name: "Name",
    actions: "Actions"
  },
  delete: {
    title: "Delete Client Instance",
    text: "Are you sure you want to delete this client-instance?<br/>You cannot undo this action."
  },
  content: {
    titleAdd: "Add new Client Instance",
    titleEdit: "Edit Client Instance",
    wltitleAdd: "Add new White Label",
    wltitleEdit: "Edit White Label",
    mainForm: {
      name: "Name",
      fromEmail: "Default from email",
      helpEmail: "Company help email"
    },
    urlSection: {
      titleadvance: "Advanced Options",
      help: "All options below require additional development configuration.",
      title: "Url Config",
      form: {
        web: "Web url",
        api: "Api url",
        media: "Media url"
      }
    },
    logoSection: {
      title: "Logo",
      help: `When uploading an image, select the area of the image that you would like to display.
      <br/>
      <strong>Logo Principal: </strong>This is the logo that appears in the upper left corner once logged in.
      <br/>
      <strong>Mobile in-app logo: </strong>This is the icon that appears in the top left corner of the mobile app when navigating the various Tasks screens and Make Ready Board.`,
      principal: "Principal logo",
      public: "Public logo",
      favicon: "Favicon logo",
      mobileInApp: "Mobile in-app logo",
      mobileSkin: "Mobile Skin logo"
    },
    themeSection: {
      title: "Theme config",
      help: `<strong>Color Primary: </strong>This is the color of the menu on the left sidebar, the main action buttons, ...
      <br/>
      <strong>Color Secondary: </strong>This is the color of the submit buttons, links, listing action icons, ...
      <br/>
      <strong>Color Tertiary: </strong>This is the background color of the central area of the web, of the cancel buttons, ...
      `,
      primary: "Primary color",
      secondary: "Secondary color",
      tertiary: "Tertiary color",
      success: "Success color",
      warning: "Warning color",
      error: "Error color",
      aux: "Aux color"
    },
    permissionsSection: {
      title: "Permissions"
    },
    adminPermissionsSection: {
      title: "Admin permissions",
      selectAll: "Select all Permissions",
      workOrder: {
        title: "Work Order",
        view: "View work orders"
      },
      template: {
        title: "Template",
        view: "View templates"
      },
      reports: {
        title: "Reports",
        view: "View reports"
      },
      dynamicForm: {
        title: "Dynamic Form",
        view: "View dynamic forms"
      },
      demand: {
        title: "On demand instructions",
        view: "View on demand instructions"
      },
      utilities: {
        title: "Utilities",
        view: "View utilities"
      }
    },
    defaultAccountPermissions: kp(Gp({}, Xn), {
      title: "Default account permissions"
    })
  }
}, Kp = {
  content: {
    title: "The Leonardo247 site is temporarily unavailable due to maintenance.",
    subtitle: "We will be back up and running again. We apologize for any inconvenience and thank you for your patience."
  }
}, Up = {
  title: "Leonardo",
  formRules: {
    required: "This field is required",
    notValid: "The value entered does not meet the requirements",
    email: "Invalid email",
    url: "Invalid url",
    pattern: "The value entered is not valid",
    minlength: "The value entered is too short, minimum is {{minlength}}",
    maxlength: "The value entered is too long, maximum is {{maxlength}}",
    passwordVerify: "Password doesn't match",
    passwordString: "Password should contains at least one character and one number"
  },
  actions: {
    submit: "Submit",
    save: "Save",
    cancel: "Cancel",
    deleteConfirm: "Yes, delete",
    reject: "Reject",
    confirm: "Confirm"
  },
  common: {
    emptyTable: "No data"
  },
  menu: {
    admin: "Admin",
    whiteLabels: "Client Instances",
    accountManagement: {
      title: "Account Management",
      accounts: "Accounts"
    },
    categoriesSubcategories: {
      title: "Categories And Subcategories",
      categories: "Categories",
      subcategories: "Subcategories"
    },
    countries: {
      title: "Countries",
      list: "List"
    },
    sectorsFields: {
      title: "Sectors And Fields",
      sectors: "Sectors",
      fieldGroups: "Field Groups",
      fieldsSubgroups: "Fields And Subgroups"
    },
    deleteProperties: "Delete Properties",
    utilities: {
      title: "Utilities",
      dfResponse: "DF Response Finder",
      importProperties: "Import Properties",
      importAmenities: "Import Properties Amenities",
      importUsers: "Import Users",
      importUnits: "Import Units",
      exportUnits: "Export Units",
      deleteUnits: "Delete Units",
      undeleteUnits: "Undelete Units",
      deletePast: "Delete Past Due Tasks",
      deleteWorkflow: "Delete Workflow Instances"
    }
  },
  imageUploader: jp,
  pagination: Rp,
  whiteLabel: Vp,
  accounts: Ap,
  maintenance: Kp
}, Bp = {
  title: "Leonardo (ES)",
  formRules: {
    required: "Este campo es obligatorio"
  }
};
function Wp(r, e) {
  var t = typeof Symbol != "undefined" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = Hp(r)) || e && r && typeof r.length == "number") {
      t && (r = t);
      var a = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return a >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[a++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = true, l = false, i;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var u = t.next();
      return o = u.done, u;
    },
    e: function(u) {
      l = true, i = u;
    },
    f: function() {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (l)
          throw i;
      }
    }
  };
}
function Hp(r, e) {
  if (!!r) {
    if (typeof r == "string")
      return eo(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return eo(r, e);
  }
}
function eo(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, a = new Array(e); t < e; t++)
    a[t] = r[t];
  return a;
}
var Yp = Object.defineProperty, zp = Object.defineProperties, qp = Object.getOwnPropertyDescriptors, to = Object.getOwnPropertySymbols, Jp = Object.prototype.hasOwnProperty, Xp = Object.prototype.propertyIsEnumerable, ao = function(e, t, a) {
  return t in e ? Yp(e, t, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: a
  }) : e[t] = a;
}, Qp = function(e, t) {
  for (var a in t || (t = {}))
    Jp.call(t, a) && ao(e, a, t[a]);
  if (to) {
    var n = Wp(to(t)), o;
    try {
      for (n.s(); !(o = n.n()).done; ) {
        var a = o.value;
        Xp.call(t, a) && ao(e, a, t[a]);
      }
    } catch (l) {
      n.e(l);
    } finally {
      n.f();
    }
  }
  return e;
}, Zp = function(e, t) {
  return zp(e, qp(t));
}, ry = {
  en: Up,
  es: Bp
}, ey = Object.entries(ry).reduce(function(r, e) {
  var t = pp(e, 2), a = t[0], n = t[1];
  return Zp(Qp({}, r), sp({}, a, {
    translation: n
  }));
}, {}), no = "en";
function ty() {
  return St.use(uo).init({
    resources: ey,
    defaultNS: "translation",
    fallbackNS: "translation",
    debug: false,
    saveMissing: true,
    lng: no,
    fallbackLng: no,
    interpolation: {
      escapeValue: false
    }
  }), St;
}
ty();
function ay(r, e) {
  var t = typeof Symbol != "undefined" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = ny(r)) || e && r && typeof r.length == "number") {
      t && (r = t);
      var a = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return a >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[a++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = true, l = false, i;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var u = t.next();
      return o = u.done, u;
    },
    e: function(u) {
      l = true, i = u;
    },
    f: function() {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (l)
          throw i;
      }
    }
  };
}
function ny(r, e) {
  if (!!r) {
    if (typeof r == "string")
      return oo(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return oo(r, e);
  }
}
function oo(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, a = new Array(e); t < e; t++)
    a[t] = r[t];
  return a;
}
var oy = Object.defineProperty, io = Object.getOwnPropertySymbols, iy = Object.prototype.hasOwnProperty, ly = Object.prototype.propertyIsEnumerable, lo = function(e, t, a) {
  return t in e ? oy(e, t, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: a
  }) : e[t] = a;
}, sy = function(e, t) {
  for (var a in t || (t = {}))
    iy.call(t, a) && lo(e, a, t[a]);
  if (io) {
    var n = ay(io(t)), o;
    try {
      for (n.s(); !(o = n.n()).done; ) {
        var a = o.value;
        ly.call(t, a) && lo(e, a, t[a]);
      }
    } catch (l) {
      n.e(l);
    } finally {
      n.f();
    }
  }
  return e;
};
function uy(r, e) {
  var t = co(r, e), a = t.i18n, n = t.ready, o = zr(function(s, u) {
    return a.t(s, u);
  }, [a]), l = zr(function(s, u) {
    return o("".concat(s), u);
  }, [o]), i = zr(function(s, u) {
    return /* @__PURE__ */ so.createElement(vo, sy({}, u), s);
  }, []);
  return {
    t: l,
    tt: o,
    i18n: a,
    ready: n,
    tHtml: i
  };
}
export {uy as useTranslation};
